import { IStudentRow } from 'api-paths-cas';

export const areStudentsEqual = (prev: Array<IStudentRow> | null, next: Array<IStudentRow> | null): boolean => {
  return prev?.length === next?.length;
};
